import { FilterType, SearchType, SortColumnType, SortOrderType } from '@shared/models';
import { createContext, Dispatch } from 'react';

export const SiteListReducerDefaultValues = {
  search: '',
  searchType: SearchType.SiteId,
  filter: FilterType.All,
  sortOrder: SortOrderType.Ascending,
  columnSort: SortColumnType.SiteId,
  zone: '',
  zoneOptions: [] as string[],
  preferencesValuesSet: false,
};

export enum SiteListActionType {
  SetSearch = 'SetSearch',
  SetSearchType = 'SetSearchType',
  SetFilter = 'SetFilter',
  SetSortOrder = 'SetSortOrder',
  SetColumnSort = 'SetColumnSort',
  SetZone = 'SetZone',
  SetZoneOptions = 'SetZoneOptions',
  SetPreferencesValuesSet = 'SetPreferencesValuesSet',
}

type State = typeof SiteListReducerDefaultValues;
type Action = {
  type: SiteListActionType;
  payload: string | SearchType | FilterType | SortOrderType | SortColumnType | string[] | boolean;
};

export const siteListReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case SiteListActionType.SetSearch:
      return {
        ...state,
        search: payload as string,
      };
    case SiteListActionType.SetSearchType:
      return {
        ...state,
        searchType: payload as SearchType,
      };
    case SiteListActionType.SetFilter:
      return {
        ...state,
        filter: payload as FilterType,
      };
    case SiteListActionType.SetSortOrder:
      return {
        ...state,
        sortOrder: payload as SortOrderType,
      };
    case SiteListActionType.SetColumnSort:
      return {
        ...state,
        columnSort: payload as SortColumnType,
      };
    case SiteListActionType.SetZone:
      return {
        ...state,
        zone: payload as string,
      };
    case SiteListActionType.SetZoneOptions:
      return {
        ...state,
        zoneOptions: payload as string[],
      };
    case SiteListActionType.SetPreferencesValuesSet:
      return {
        ...state,
        preferencesValuesSet: payload as boolean,
      };
    default:
      return state;
  }
};

export const SiteListContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
